import Chart from 'chart.js/auto'

import annotationPlugin from 'chartjs-plugin-annotation';
import 'chartjs-adapter-date-fns';

(async function() {
    const rawData = [
        { time : '2025-01-01 08:00', systolic: 120, diastolic: 80 },
        { time : '2025-01-02 08:00', systolic: 130, diastolic: 85 },
        { time : '2025-01-03 08:00', systolic: 125, diastolic: 82 },
        { time : '2025-01-03 12:00', systolic: 135, diastolic: 86 },
        { time : '2025-01-03 18:00', systolic: 145, diastolic: 87 },
        { time : '2025-01-04 08:00', systolic: 140, diastolic: 88 },
    ];

    const datasets = [
        {
            label: 'Systolic',
            data: rawData.map(raw => { return { x: raw.time, y: raw.systolic }}),
            borderColor: 'red',
            fill: false
        },
        {
            label: 'Diastolic',
            data: rawData.map(raw => { return { x: raw.time, y: raw.diastolic }}),
            borderColor: 'blue',
            fill: false
        },
    ];

    Chart.register(annotationPlugin);

    new Chart(
        document.getElementById('pressure'),
        {
            type: 'line',
            data: {
                datasets,
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'minute',
                            displayFormats: {
                                minute: 'HH:mm',
                            },
                        },
                        ticks: {
                            stepSize: 30,

                        },
                        title: { display: true, text: 'Date' }
                    },
                    y: {
                        title: { display: true, text: 'mmHg' },
                        min: 40,
                        max: 180
                    }
                },
                plugins: {
                    annotation: {
                        annotations: {
                            highSystolic: {
                                type: 'line',
                                yMin: 120,
                                yMax: 120,
                                borderColor: 'rgb(255, 99, 132)',
                                borderWidth: 5,
                            },
                            highDiastolic: {
                                type: 'line',
                                yMin: 80,
                                yMax: 80,
                                borderColor: 'rgb(99, 132, 255)',
                                borderWidth: 5,
                            },
                        }
                    }
                }
            }
        }
    );
})();
